/*global Q */
var
    /** @type {function(new:diy.social.FacebookShare)} */
    FacebookShare = require('diy/social/FacebookShare'),
    /** @type {function(new:diy.social.TwitterShare)} */
    TwitterShare = require('diy/social/TwitterShare'),
    /** @type {function(new:diy.social.LinkedInShare)} */
    LinkedInShare = require('diy/social/LinkedInShare'),
    /** @type {function(new:diy.social.XingShare)} */
    XingShare = require('diy/social/XingShare'),
    /** @type {diy.util.websiteData} */
    websiteData = require('diy/util/websiteData'),

    /**
     *
     * @returns {*}
     */
    getConfig = function () {
        var config = websiteData.getData('social');
        if (typeof config !== 'object') {
            config = {};
        }
        return config;
    },
    /**
     *
     * @param $container {jQuery}
     * @param properties {Array.<
     *  {
     *      type: String,
     *      options: {
     *          url: String,
     *          image: String | undefined,
     *          onClick: Function | undefined,
     *          onSubmit: Function | undefined,
     *          message: {
     *              text: String | undefined,
     *              tags: String | undefined
     *          } | undefined,
     *          actions : [{
     *              name: String,
     *              link: String
     *          }] | undefined,
     *          appId: String | undefined
     *      }
     *  }
     * >}
     * @returns {Promise|Q.promise}
     */
    render = function ($container, properties) {
        var buttons, whenReady = [];
        if (!(properties instanceof Array)) {
            buttons = [properties];
        } else {
            buttons = properties;
        }
        buttons.forEach(function (button) {
            var instance = null;
            switch (button.type) {
                case 'facebookShare':
                    instance = new FacebookShare($container, button.options);
                    break;
                case 'twitterShare':
                    instance = new TwitterShare($container, button.options);
                    break;
                case 'linkedInShare':
                    instance = new LinkedInShare($container, button.options);
                    break;
                case 'xingShare':
                    instance = new XingShare($container, button.options);
                    break;
                default:
                    throw new Error('Undefined button type ' + button.type);
            }

            whenReady.push(Q(instance.render.call(instance)));
        });

        return Q.all(whenReady);
    };

/**
 * @class diy.social.social
 * @template diy.social.social
 * @lends {diy.social.social.prototype}
 * @constructor
 */
module.exports = {
    render: render,
    config: getConfig()
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/social/social.js
 ** module id = 734
 ** module chunks = 0
 **/